var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "app-main-inner econtainer-history",
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("SeaExport.ElectronicBoxListSendingHistory"),
        width: "700px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "app-main-inner-row row-grid-dialog",
          staticStyle: { "padding-top": "0" }
        },
        [
          _c("cargo-ag-grid", {
            staticStyle: { width: "100%" },
            attrs: {
              "show-side-bar": false,
              "grid-params": _vm.gridParams,
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.rowData
            },
            on: {
              "update:gridParams": function($event) {
                _vm.gridParams = $event
              },
              "update:grid-params": function($event) {
                _vm.gridParams = $event
              }
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }